/**
 * Convert a value to a valid Number. This also work for comma separated values.
 * @param {number|string} value
 */
export function convertToNumber(value) {
  return typeof value === 'number' ? value : Number(value.replace(/,/g, ''))
}

/**
 * Interpolation function utilizes the slope intercept equation
 * to calculate missing population values in the passed data array.
 * @param {number} x – year
 * @param {number} index - index of the passed array object
 * @param {Array} array - the data array containig the object entries for year and population
 * @returns {number} - interpolated value
 */
export function interpolate(x, index, array) {
  const { year: x1, population: y1 } = array
    .slice(0, index)
    .reverse()
    .find(({ population }) => population > 0)
  const { year: x2, population: y2 } = array
    .slice(index + 1, array.length)
    .find(({ population }) => population > 0)

  // slope intercept function form y = mx + b
  // slope = m = change of y divided on change of x
  const m = (y2 - y1) / (x2 - x1)
  // find slope intercept (b) for previous year
  const b = y1 - m * x1
  // then use the equation to interpolate the value of x
  // y = m * x + b, y is interpolatedValue for unknown population count
  return Math.ceil(m * x + b)
}

/**
 * Converts year to a valid Date
 * @param {string|number} year
 */
export function formatYear(year) {
  return new Date(`${year}`)
}

/**
 * Returns true if year is active, false other wise.
 * @param {number} year
 * @param {number} activeYear
 * @returns {boolean}
 */
export function isActive(year, activeYear) {
  return year >= activeYear && year <= activeYear + 9
}

/**
 * Convert string to HTML
 * @param {string} body
 */
export function createMarkup(body) {
  return { __html: body }
}

export const debounce = (func, wait, immediate) => {
  let timeout
  return () => {
    let later = () => {
      timeout = null
      if (!immediate) func.apply(this)
    }

    let callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)

    if (callNow) func.apply(this)
  }
}
